export default "__VITE_ASSET__BaSsF5nZ__"